import LotSearch from 'components/Search/LotSearch'

import createWrappedField from './createWrappedField'

export default createWrappedField({
  Component: LotSearch,
  name: 'DDILotSearch'
})
